import { render, staticRenderFns } from "./categoryView.vue?vue&type=template&id=3f5ae610&"
import script from "./categoryView.vue?vue&type=script&lang=js&"
export * from "./categoryView.vue?vue&type=script&lang=js&"
import style0 from "./categoryView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports